"use client";

import { useState, type ReactNode } from "react";

type FormShellProps = {
  id: string;
  action: string;
  submitLabel: string;
  pendingLabel?: string;
  children: ReactNode;
  /** Rendered next to the submit button (e.g. a WhatsApp alternative). */
  aside?: ReactNode;
};

/**
 * Native POST form (works without JavaScript, the API answers with a 303).
 * Only adds a disabled "sending" state so the form cannot be submitted twice.
 */
export function FormShell({ id, action, submitLabel, pendingLabel = "Envoi en cours…", children, aside }: FormShellProps) {
  const [pending, setPending] = useState(false);

  return (
    <form
      id={id}
      action={action}
      method="POST"
      className="space-y-6"
      onSubmit={(event) => {
        if (!event.currentTarget.checkValidity()) return;
        setPending(true);
      }}
    >
      {children}
      <div className="flex flex-col sm:flex-row gap-4 pt-2">
        <button
          type="submit"
          disabled={pending}
          aria-busy={pending}
          className="inline-flex items-center justify-center min-h-12 px-8 py-3 rounded-full text-base font-semibold text-[var(--ivory)] bg-[var(--copper-dark)] hover:bg-[#7d3d0e] transition-colors disabled:opacity-70 disabled:cursor-wait focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--copper-dark)] focus-visible:ring-offset-2"
        >
          {pending ? pendingLabel : submitLabel}
        </button>
        {aside}
      </div>
    </form>
  );
}
